<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">
        User {{ $route.params.id ? "Edit" : "Add" }}
      </h1>
      <input-switch label="Active" v-model="user.active"></input-switch>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column">
          <input-field
            v-model="user.employeeId"
            label="Employee ID"
            :valid="employeeIDValid"
            required
          ></input-field>
        </div>
        <div class="column">
          <input-field
            v-model="user.name"
            label="Name"
            :valid="nameValid"
            required
          ></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <input-field
            v-model="user.mobile"
            label="Mobile"
            type="tel"
            :valid="mobileValid"
            required
          ></input-field>
        </div>
        <div class="column">
          <input-field
            v-model="user.email"
            label="Email"
            type="email"
            :valid="emailValid"
            optional
          ></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <input-select
            label="Role"
            v-model="user.role"
            :valid="roleValid"
            required
          >
            <option value="engineer">Engineer</option>
            <option value="admin">Admin</option>
          </input-select>
        </div>
        <div class="column">
          <input-field
            v-model="user.password"
            label="Password"
            type="password"
            :valid="passwordValid"
            required
          ></input-field>
        </div>
      </div>
      <p class="has-text-center has-text-danger">{{ errorMessage }}</p>
      <hr />
      <div class="is-flex">
        <div class="is-expanded">
          <button class="button is-borderless" @click="onCancelClicked">
            Cancel
          </button>
        </div>
        <div class="is-expanded has-text-right">
          <button
            class="button is-primary"
            :disabled="!formValid"
            @click="onSaveClicked"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import validator from "validator";
export default {
  data() {
    return {
      user: {
        employeeId: "",
        name: "",
        mobile: "",
        email: "",
        role: "",
        password: "",
        active: true
      },
      loading: false,
      errorMessage: ""
    };
  },
  methods: {
    onCancelClicked() {
      let component = this;
      component.$router.go(-1);
    },
    onSaveClicked() {
      let component = this;
      component.loading = true;
      component.$store
        .dispatch(
          component.user._id ? "user/update" : "user/store",
          component.user
        )
        .then(response => {
          component.loading = false;
          component.$router.push(`/user/view/${response.data.user._id}`);
        })
        .catch(error => {
          component.loading = false;
          console.log("fail");
          if (
            error.response.status === 500 &&
            error.response.data.error.code === 11000
          ) {
            component.errorMessage = error.response.data.error.errmsg;
          }
        });
    }
  },
  computed: {
    employeeIDValid() {
      let component = this;
      return (
        component.user.employeeId.length > 3 &&
        validator.isAlphanumeric(component.user.employeeId) &&
        validator.isUppercase(component.user.employeeId)
      );
    },
    nameValid() {
      let component = this;
      return component.user.name.length > 3;
    },
    mobileValid() {
      let component = this;
      return validator.isMobilePhone(component.user.mobile);
    },
    emailValid() {
      let component = this;
      return component.user.email.length > 0
        ? validator.isEmail(component.user.email)
        : true;
    },
    roleValid() {
      let component = this;
      return (
        component.user.role === "engineer" || component.user.role === "admin"
      );
    },
    passwordValid() {
      let component = this;
      return component.user.password.length > 0
        ? component.user.password.length > 5
        : true;
    },
    formValid() {
      let component = this;
      let validationRules = [
        component.employeeIDValid,
        component.nameValid,
        component.emailValid,
        component.roleValid,
        component.passwordValid
      ];
      for (let i = 0; i < validationRules.length; i++) {
        if (!validationRules[i]) {
          return false;
        }
      }
      return true;
    }
  },
  mounted() {
    let component = this;
    component.loading = true;
    if (component.$route.params.id) {
      component.$store
        .dispatch("user/show", component.$route.params.id)
        .then(response => {
          response.data.password = "";
          component.user = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
